// Auth initialization flag — prevents 401 handler from redirecting during auth code exchange
export let authInitInProgress = false;
export function setAuthInitInProgress(v) { authInitInProgress = v; }
